import { createStyles, getStylesRef, rem } from "@mantine/core";

export const useStyles = createStyles((theme) => ({
  main: {
    [theme.fn.smallerThan("sm")]: {
        minHeight: "calc(100vh - 60px)"
    }
  },
  
}));